import Heading from 'sly/system/Heading';

export default function ProviderIndexHeader() {
  return (
    <div>
      <Heading as='h1' font='font-t-l md:font-t-xl'>
        All Senior Living Providers
      </Heading>
      <div className='flex flex-col gap-y-4 pt-6'>
        <div className='font-b-m max-w-3xl'>
          Senior living companies range from very large providers, with hundreds
          of locations around the country (and even world), to small &quot;mom
          and pop,&quot; family-run businesses with only one or two locations.
          There are benefits to each type, and you can learn more about some of
          the biggest senior living providers by clicking the names of each
          below.
        </div>
        <div className='font-b-m max-w-3xl'>
          When you&apos;re researching senior living options it&apos;s also a
          good idea to investigate the senior living company that manages each
          property you&apos;re interested in. This can show you what type of
          care they specialize in, whether they&apos;ve won recognition in the
          field, and how they organize themselves and their care. For example,
          while some large providers&apos; communities follow care programming
          set by experts at the corporate level, others give each of their
          communities free rein to customize their activities and programming.
        </div>
        <div className='font-b-m max-w-3xl'>
          While each senior living company is different, from management
          practices to care types offered, all are dedicated to caring for older
          adults with respect. Select a provider below to learn more about what
          types of care they offer, what awards they&apos;ve won, and how they
          approach the business of providing safe, comfortable homes for older
          adults to thrive in.
        </div>
      </div>
    </div>
  );
}
